import React from "react";
import { SimpleShowLayout, TextField } from "react-admin";

const Tab = (props) => {
  return (
    <SimpleShowLayout {...props}>
      <TextField source="basketball.id" />
      <TextField source="basketball.playerGameCount" />
      <TextField source="basketball.totalPoints" />
      <TextField source="basketball.rebounds" />
      <TextField source="basketball.assists" />
      <TextField source="basketball.threePointFieldGoals" />
      <TextField source="basketball.pointsPerGame" />
      <TextField source="basketball.reboundsPerGame" />
      <TextField source="basketball.assistsPerGame" />
      <TextField source="basketball.threePointFieldGoalsPerGame" />
    </SimpleShowLayout>
  );
};

export default Tab;
